import { SGTooltip } from '../core';
import {
  IconButton,
  SxProps,
  Button,
  useTheme,
  TooltipProps,
} from '@mui/material';
import { ReactElement } from 'react';

type ChartSizingButtonProps = {
  withText?: boolean;
  onClick: () => void;
  icon: ReactElement;
  buttonSx?: SxProps;
  title: string;
  tooltipPlacement?: TooltipProps['placement'];
  id?: string;
};
export const ChartSizingButton = ({
  withText,
  onClick,
  icon,
  buttonSx,
  title,
  tooltipPlacement,
  id,
}: ChartSizingButtonProps) => {
  const theme = useTheme();
  return (
    <SGTooltip
      title={(withText ?? false) ? undefined : title}
      placement={tooltipPlacement ?? 'bottom'}
    >
      {(withText ?? false) ? (
        <Button
          id={id ?? 'chart-sizing-button'}
          startIcon={icon}
          sx={{
            fontSize: '12px',
            textDecoration: 'none',
            textTransform: 'none',
            marginLeft: '2px',
            color: theme.palette.text.primary,
            ...buttonSx,
          }}
          onClick={onClick}
          size="medium"
          className="canvas-no-drag"
        >
          {title}
        </Button>
      ) : (
        <IconButton
          id={id ?? 'chart-sizing-button'}
          sx={{
            fontSize: '12px',
            textDecoration: 'none',
            marginLeft: '2px',
            ...buttonSx,
          }}
          onClick={onClick}
          size="medium"
          color="primary"
          className="canvas-no-drag"
        >
          {icon}
        </IconButton>
      )}
    </SGTooltip>
  );
};
